import { withRouter } from "found";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import convertDocumentToTemplate from "pstat-anywhere/components/document_control/view_policy/ConvertDocumentToSystemTemplateMutation";
import { EnvironmentContext } from "pstat-anywhere/context_providers/EnvironmentContext";
import { isActive } from "pstat-anywhere/utils/document";
import { getRootUrl } from "pstat-anywhere/utils/urls";
import { createErrorMessage } from "pstat-design-system/message/manageMessages";
import { Button } from "pstat-design-system/shared/Button";

export const ConvertToTemplateButton = withRouter(
  ({ documentPk, router, ...otherProps }) => {
    const { t } = useTranslation();
    const environment = useContext(EnvironmentContext);
    const handleClick = () => {
      const variables = {
        input: {
          documentPk
        }
      };
      convertDocumentToTemplate(environment, variables, (response, errors) => {
        if (errors) {
          createErrorMessage(
            t("systemDocumentTemplates.convertToTemplateError")
          );
        }
        const {
          ok,
          systemDocumentTemplateId
        } = response.systemDocumentTemplateFromDocument;
        if (ok) {
          router.push(
            `${getRootUrl()}/template/${systemDocumentTemplateId}/?converted=1`
          );
        } else {
          createErrorMessage(
            t("systemDocumentTemplates.convertToTemplateError")
          );
        }
      });
    };
    return (
      <Button buttonStyle="tertiary" onClick={handleClick} {...otherProps}>
        {t("systemDocumentTemplates.convertToTemplateButton")}
      </Button>
    );
  }
);

export const canConvertToTemplate = (document, tenant, viewer) => {
  if (!isActive(document.status)) {
    return false;
  }
  if (document.bloc.tenants.length > 1) {
    return false;
  }
  if (!tenant.customerSettings.enableEnterprisePolicySharing) {
    return false;
  }
  if (!tenant.enableEnterprise) {
    return false;
  }
  if (!viewer.userAuth.isSiteAdmin) {
    return false;
  }
  return true;
};
